import { render, staticRenderFns } from "./CloudAPRates.vue?vue&type=template&id=5067547c"
import script from "./CloudAPRates.vue?vue&type=script&lang=js"
export * from "./CloudAPRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports